export const payload = {
  receiveMutation: 'RECEIVE_AR',
  receiveMetadataMutation: 'RECEIVE_AR_METADATA',
  savingMutation: 'SAVING_AR',
  incrementMutation: 'INCREMENT_AR_COUNT',
  updatingMutation: 'UPDATING_AR',
  resetMetaMutation: 'RESET_AR_META',
  clearMutation: 'CLEAR_AR_STATE',
  moduleName: 'ar',
  endpoint: 'ars'
}



// WEBPACK FOOTER //
// ./src/components/RouteComponents/Ars/actionPayload.js